<script setup>
/**
 * FormControlTemplatesTemplatesContentType
 * A component that conditionally renders a content type selector.
 * If the form is editing an existing record and beta mode is off, it displays plain text.
 * Otherwise, it shows a dropdown select. The visibility and requirement of the field
 * are dynamically adjusted based on the template's 'type' property.
 */
import { computed, watch, getCurrentInstance } from 'vue';
import FormControlPlainText from "./FormControlPlainText.vue";
import FormControlTypeSelect from "../form-control-type/FormControlTypeSelect.vue";

const { proxy } = getCurrentInstance();
const store = proxy.$store;

const props = defineProps({
    formId: String,
    field: Object,
    currentData: Object,
});

const betaMode = computed(() => store.state.betaMode);
const type = computed(() => props.currentData.type);

// This logic runs once on setup, equivalent to the 'created' hook
props.field.options = [
    {value: 'Basic', text: 'Basic'},
    {value: 'Basket', text: 'Basket'},
    {value: 'Categories', text: 'Categories'},
    {value: 'Filter', text: 'Filter'},
    {value: 'Form', text: 'Form'},
    {value: 'Listing', text: 'Listing'},
    {value: 'Listing component', text: 'Listing component'},
    {value: 'Magic link form', text: 'Magic link form'},
    {value: 'Misc.', text: 'Misc.'},
    {value: 'Navigation', text: 'Navigation'},
    {value: 'Product filter', text: 'Product filter'},
    {value: 'Product navigation', text: 'Product navigation'},
    {value: 'Registration form', text: 'Registration form'},
    {value: 'Tags', text: 'Tags'},
    {value: 'Teaser', text: 'Teaser'}
];

store.dispatch(`${props.formId}/setDefaultValue`, {
    name: props.field.name,
    value: '',
});

watch(type, (newType) => {
    const visible = newType === 'contentType';
    props.field.visibility = visible ? '' : 'hidden';
    props.field.required = visible;
    if (!visible) {
        props.currentData[props.field.name] = '';
    }
}, { immediate: true });

</script>

<template>
    <FormControlPlainText v-if="currentData.id && !betaMode" :value="currentData[field.name]" :form-id="formId"/>
    <FormControlTypeSelect v-else :current-data="currentData" :field="field" :form-id="formId"/>
</template>